import {schema} from 'normalizr'

export const solution = new schema.Entity('problem_solution')
export const arrayOfSolution = new schema.Array(solution)

export const problem = new schema.Entity('problem')
problem.define({
  solutions: arrayOfSolution
})
const arrayOfProblem = new schema.Array(problem)

export const explanation = new schema.Entity('explanation')
const arrayOfExplanation = new schema.Array(explanation)

export const topic = new schema.Entity('topic')
const arrayOfTopic = new schema.Array(topic)

topic.define({
  'children': arrayOfTopic,
  'leaves': arrayOfTopic,
  'parent':topic,
  'explanations': arrayOfExplanation,
  'problems': arrayOfProblem
})

export const gmProblem = new schema.Entity('gmProblem')
gmProblem.define({
  'topic': topic,
  'baseTopic': topic,
  'problem': problem
})

const journeyEntry = new schema.Entity('journey')
journeyEntry.define({
  'topic': topic
})

export const journey = new schema.Array(journeyEntry)



// WEBPACK FOOTER //
// ./src/redux/schema.js